import {Component, Input} from '@angular/core';
import {CommonSvgIconsComponent} from "../../../shared/components/common-svg-icons/common-svg-icons.component";
import {NewVehicleComponent} from "./new-vehicle/new-vehicle.component";
import {NgClass, NgIf} from "@angular/common";
import {ProcedureVehicleComponent} from "./procedure-vehicle/procedure-vehicle.component";
import {LeasingVehicleComponent} from "./leasing-vehicle/leasing-vehicle.component";
import {ReactiveFormsModule} from "@angular/forms";
import {ConfirmationVehicleComponent} from "./confirmation-vehicle/confirmation-vehicle.component";

@Component({
  selector: 'app-vehicle',
  standalone: true,
  imports: [
    CommonSvgIconsComponent,
    NewVehicleComponent,
    NgClass,
    ProcedureVehicleComponent,
    LeasingVehicleComponent,
    ReactiveFormsModule,
    ConfirmationVehicleComponent,
    NgIf
  ],
  templateUrl: './vehicle.component.html',
  styleUrl: './vehicle.component.scss'
})
export class VehicleComponent {
  dataFromParent = { vehicleId: 0 };
  public activeSteps!: number;
  public completedSteps = new Set<number>(); // Para permitir o bloquear acceso por tab
  public addProductTabData = [
    {
      id: "vehicle-detail-tab",
      svg: "product-detail",
      title: "Agregar nuevo vehículo",
      subTitle: "Información general",
      active: true,
      steps: 1
    },
    {
      id: "vehicle-procedure-tab",
      svg: "product-gallery",
      title: "Trámites",
      subTitle: "Agrega información de los trámites del vehículo",
      active: false,
      steps: 2
    },
    {
      id: "leasing-tab",
      svg: "product-category",
      title: "Leasing",
      subTitle: "Leasing",
      active: false,
      steps: 3
    },
    {
      id: "vehicle-confirmation-tab",
      svg: "pricing",
      title: "Confirmación de alta",
      subTitle: "Inicio de operaciones del vehículo",
      active: false,
      steps: 4
    },
  ];

  ngOnInit() {
    const data = this.addProductTabData.filter((data) => {
      return data.steps === 1;
    });
    this.activeSteps = data[0].steps;
  }

  receiveChildData(step: number) {
    //this.completedSteps.add(this.activeSteps); // Marca el paso actual como completado
    this.activeSteps = step;
  }

  updateData(idVehicle: number){
    this.dataFromParent.vehicleId = idVehicle;
  }

  goToStep(step: number){
    this.activeSteps = step;
    /*if (this.isStepAvailable(step)) {
      this.activeSteps = step;
    }*/
  }

  isStepAvailable(step: number): boolean {
    return this.dataFromParent.vehicleId !== 0 || step === 1;
    //return step === 1 || this.completedSteps.has(step - 1);
  }
}
